import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=9f5caa4a&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5caa4a')) {
      api.createRecord('9f5caa4a', component.options)
    } else {
      api.reload('9f5caa4a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=9f5caa4a&", function () {
      api.rerender('9f5caa4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Calendar/Index.vue"
export default component.exports